export default {
  login:{
    login:'wx/weiji/login',
  },




}
